/* unplugin-vue-components disabled */import { render } from "./member_department_xq.vue?vue&type=template&id=5bf420ea&scoped=true"
import script from "./member_department_xq.vue?vue&type=script&lang=js"
export * from "./member_department_xq.vue?vue&type=script&lang=js"

import "./member_department_xq.vue?vue&type=style&index=0&id=5bf420ea&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5bf420ea"]])

export default __exports__